import jsPDF from "jspdf";
import logoGiuvi from "../../assets/logoHeader_red.png";

const loadImage = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = () => resolve(img);
    img.onerror = (e) => {
      // If CORS fails or other error, resolve with null to allow PDF generation to continue without image
      console.warn("Image load failed", url, e);
      resolve(null);
    };
    img.src = url;
  });
};

export const generateBadgePDF = async (userData) => {
  // 90mm x 50mm landscape
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: [90, 50],
  });

  // Set default font
  doc.setFont("helvetica", "normal");

  // Helper function for text
  const addText = (
    text,
    x,
    y,
    size,
    align = "left",
    weight = "normal",
    color = "#000000"
  ) => {
    doc.setFontSize(size);
    doc.setFont("helvetica", weight);
    doc.setTextColor(color);
    doc.text(String(text), x, y, { align });
  };

  // --- HEADER ---
  // Logo
  try {
    const logoImg = await loadImage(logoGiuvi);
    if (logoImg) {
      doc.addImage(logoImg, "PNG", 3, 3, 15, 5); // x, y, w, h
    }
  } catch (e) {
    console.error("Logo load error", e);
  }

  // Badge Type Box
  doc.setDrawColor(51, 51, 51);
  doc.setLineWidth(0.1);
  doc.roundedRect(69, 3, 18, 4, 1, 1);
  addText("TESSERINO", 78, 5.8, 6, "center", "bold", "#333333");

  // Red separator line
  doc.setDrawColor(183, 28, 28); // #b71c1c
  doc.setLineWidth(0.5);
  doc.line(3, 10, 87, 10);

  // --- PHOTO ---
  const photoY = 12;
  const photoH = 25;
  const photoW = 20;
  const photoX = 4; // Left aligned with some margin

  try {
    const photoUrl = userData.foto;
    const photoImg = await loadImage(photoUrl);

    if (photoImg) {
      doc.addImage(photoImg, "JPEG", photoX, photoY, photoW, photoH);
      // Border around photo
      doc.setDrawColor(221, 221, 221);
      doc.setLineWidth(0.1);
      doc.rect(photoX, photoY, photoW, photoH);
    } else {
      // Placeholder
      doc.setDrawColor(200, 200, 200);
      doc.rect(photoX, photoY, photoW, photoH);
      addText("No Photo", photoX + photoW / 2, photoY + 12, 6, "center");
    }
  } catch (e) {
    doc.rect(photoX, photoY, photoW, photoH);
  }

  // --- MAIN INFO ---
  // Right side starting X
  const contentX = 28;
  let currentY = 15;

  // Name
  addText(
    `${userData.cognome} ${userData.nome}`,
    contentX,
    currentY,
    10,
    "left",
    "bold",
    "#000000"
  );

  // Role
  currentY += 4;
  addText(userData.ruolo, contentX, currentY, 8, "left", "normal", "#666666");

  // Separator
  currentY += 2;
  doc.setDrawColor(238, 238, 238);
  doc.setLineWidth(0.2);
  doc.line(contentX, currentY, 87, currentY);

  // --- DETAILS ---
  currentY += 4;

  const addDetailRow = (label, value, y, xLabel, xValue) => {
    // Label
    addText(label, xLabel, y, 5, "left", "normal", "#999999");
    // Value
    addText(value, xValue, y, 5, "left", "normal", "#000000");
  };

  // Two columns for details
  // Col 1: Employee Details (x=28)
  // Col 2: Company Details (x=58)

  const col1X = 28;
  const col1ValueX = 38; // Label width approx 10

  const col2X = 58;
  const col2ValueX = 70; // Label width approx 12

  const startDetailsY = currentY;

  // --- Col 1: Employee Data ---
  addText(
    "Dati dipendente",
    col1X,
    startDetailsY,
    6,
    "left",
    "bold",
    "#333333"
  );
  doc.setDrawColor(200, 200, 200);
  doc.line(col1X, startDetailsY + 1, col1X + 25, startDetailsY + 1);

  let dY = startDetailsY + 3.5;
  addDetailRow("Nato il:", userData.dataNascita, dY, col1X, col1ValueX);
  dY += 3;
  addDetailRow("A:", userData.luogoNascita, dY, col1X, col1ValueX);
  dY += 3;
  addDetailRow("C.F.:", userData.codiceFiscale, dY, col1X, col1ValueX);

  // --- Col 2: Company Data ---
  addText("Dati aziendali", col2X, startDetailsY, 6, "left", "bold", "#333333");
  doc.line(col2X, startDetailsY + 1, col2X + 25, startDetailsY + 1);

  dY = startDetailsY + 3.5;
  addDetailRow("Indirizzo", "Via Belgirate, 15 - MI", dY, col2X, col2ValueX);
  dY += 3;
  addDetailRow("P.IVA", "07873720960", dY, col2X, col2ValueX);
  dY += 3;
  addDetailRow("REA", "MI-2010873", dY, col2X, col2ValueX);
  dY += 3;
  addDetailRow("INPS", "PA 4978037989", dY, col2X, col2ValueX);
  dY += 3;
  addDetailRow("INAIL", "PAT 19083034/46", dY, col2X, col2ValueX);
  dY += 3;
  addDetailRow("Tel", "+39 02 97 19 03 15", dY, col2X, col2ValueX);

  // Save
  doc.save(
    `badge_${userData.cognome.replace(/\s+/g, "_")}_${userData.nome.replace(
      /\s+/g,
      "_"
    )}.pdf`
  );
};
